import type { Rfc9457ProblemDetails } from "../api-client/endpoints";

export class Rfc9457Error extends Error {
  constructor(public readonly details: Rfc9457ProblemDetails) {
    super(details.detail);
    this.name = "Rfc9457Error";
  }
}
